window.addEventListener("DOMContentLoaded", () => {
	// AOS.init({
    //     duration: 1000,
    //     delay: 100,
    //     once: true
    // });
});
// import './contact'
import './hdgcontact'
import './main'
import './projectMenu'
import './form-thank-you'
import './galleries'
import './slider'